export default __webpack_public_path__ + "static/media/ILMS.0812279e.png";